import { fmt } from "@/lib/format";

// 직전 구간 대비 증감(2026-07-18) — 기간 표의 핵심 숫자 아래 "+12 · +35%" 한 줄.
// 사용량·손익·지출 표가 공유한다. 규칙:
//  · 직전 구간이 없거나(가장 오래된 행) 두 구간 모두 0이면 표시하지 않는다(빈 기간 소음 방지)
//  · %는 직전 값이 양수일 때만 — 0이나 음수 대비 비율은 의미가 없다
//  · 누적 모드에선 hidden — 누적의 증감 = 그 구간 발생량이라 중복 정보
// format 은 절대값 표기 함수(부호는 여기서 붙인다). 기본은 정수, 돈은 fmt.krw/fmt.usd 전달.
export default function RowDelta({ cur, prev, hidden = false, format = (v) => fmt.int(v) }) {
  if (hidden || prev == null || (cur === 0 && prev === 0)) return null;
  const delta = cur - prev;
  const pct = prev > 0 ? (delta / prev) * 100 : null;
  const cls = delta > 0 ? "text-emerald-600" : delta < 0 ? "text-red-500" : "text-ink-300";
  const sign = delta > 0 ? "+" : delta < 0 ? "−" : "±";
  return (
    <div className={`text-[11px] font-normal leading-tight ${cls}`}>
      {sign}{format(Math.abs(delta))}
      {pct != null && <> · {sign}{Math.abs(pct) >= 1000 ? fmt.int(Math.abs(pct)) : Math.abs(pct).toFixed(0)}%</>}
    </div>
  );
}
